<template>
  <TableGradient
      icon-name="filter"
      :title="$t('tuevs.material.listagem.titulo_pagina')"
      :items="materials"
      table-data
      :fields="fields"
      :loading="isLoading"
      :paginator="pagination"
      :text-empty="$t('tuevs.material.listagem.table.empty')"
      route-new="tuevs.material.create"
      :text-new="$t('tuevs.material.listagem.novo')"
      @list="evt => $store.dispatch('tuevs/material/listAll', evt)">
    <template v-slot:cell(status)="linha">
      <span
          :class="{'rounded-pill p-1 badge':true, 'badge-success':linha.item.status, 'badge-danger': !linha.item.status}">
          <em v-if="linha.item.status">{{ $t('tuevs.material.listagem.habilitado') }}</em>
          <em v-else>{{ $t('tuevs.material.listagem.desabilitado') }}</em>
      </span>
    </template>
    <template v-slot:cell(id)="linha">
      <router-link :id="'link-edit-' + linha.index" :to="{ name: 'tuevs.material.edit', params: { id: linha.item.id }}"
                   class="font-weight-bold">
        {{ $t('tuevs.material.listagem.table.editar') }}
      </router-link>
    </template>
  </TableGradient>
</template>

<script>
import TableGradient from "@/templates/TableGradient";
import {mapActions, mapGetters} from 'vuex'

export default {
  name: "Index",
  components: {TableGradient},
  computed: {
    ...mapGetters({
      store_isLoading: 'tuevs/material/isLoading',
      materials: 'tuevs/material/all',
      pagination: 'tuevs/material/pagination'
    }),
    isLoading() {
      return !(this.mounted && this.store_isLoading === false)
    }
  },
  data() {
    return {
      mounted: false,
      fields: [
        {key: 'name', label: this.$t('tuevs.material.listagem.table.nome'), sortable: true},
        {key: 'code', label: this.$t('tuevs.material.listagem.table.codigo'), sortable: true},
        {key: 'status', label: 'Status', sortable: true},
        {key: 'id', label: this.$t('tuevs.material.listagem.table.editar')}
      ]
    }
  },
  methods: {
    ...mapActions([
      'tuevs/material/listAll'
    ])
  },
  mounted() {
    this['tuevs/material/listAll']()
    this.mounted = true
  }
}
</script>

<style lang="scss" scoped>
</style>
